import { addItem, takeItem } from "./inventory";
import type { WorldState } from "./types";

export function enterHome(w: WorldState): void {
  w.player.overworldX = w.player.x;
  w.player.overworldY = w.player.y;
  w.prevMode = w.mode;
  w.mode = "home";
  w.player.x = 6.5;
  w.player.y = 8.2;
  w.player.vx = 0;
  w.player.vy = 0;
  w.home.visits += 1;
  w.home.dirt = Math.min(1, w.home.dirt + 0.04);
}

/** The table remembers what the county already wrote. */
export function chronicle(w: WorldState): string {
  const lines = w.log.filter((e) => e.kind === "story" || e.kind === "faction").slice(0, 4);
  if (lines.length === 0) return "The table is empty. Nothing has happened yet that the house will keep.";
  return lines.map((e) => e.text).join(" ");
}

export function leaveHome(w: WorldState): void {
  w.mode = "overworld";
  w.player.x = w.overworld.homeDoor.x + 0.5;
  w.player.y = w.overworld.homeDoor.y + 1.2;
  w.player.vx = 0;
  w.player.vy = 0;
}

export function stashAll(w: WorldState): number {
  let n = 0;
  for (const s of [...w.bag]) {
    if (addItem(w.home.chest, { ...s, meta: s.meta }, 40)) {
      takeItem(w.bag, s.id, s.n);
      n += s.n;
    }
  }
  return n;
}

export function placeOnBench(w: WorldState): boolean {
  const art = w.bag.find((s) => s.id === "artifact" || s.id === "survey_plate");
  if (!art) return false;
  const slot = w.home.bench.findIndex((b) => !b);
  if (slot < 0) return false;
  w.home.bench[slot] = { id: art.id, n: 1, meta: art.meta };
  takeItem(w.bag, art.id, 1);
  if (art.id === "artifact" && !w.home.trophies.includes("first-thing")) {
    w.home.trophies.push("first-thing");
  }
  return true;
}

export function homeVisualWeight(w: WorldState): number {
  return (
    w.home.visits * 0.02 +
    w.home.trophies.length * 0.2 +
    w.home.bench.filter(Boolean).length * 0.15 +
    w.home.chest.length * 0.03 +
    w.extracts * 0.08
  );
}
